import { request } from './http';
import type {
  SimulateTransactionRequest,
  SimulateTransactionResult,
} from '@/types/mockSimulate';

export const adminMockSimulateApi = {
  simulateTransaction(payload: SimulateTransactionRequest) {
    return request<SimulateTransactionResult>({
      url: '/admin/mock/simulate-transaction',
      method: 'POST',
      data: payload,
    });
  },
};
